import React from "react";

export default function CurrentStepShow({ currentStep, number }) {
   let manageStepClass = "";

   if (currentStep === number) {
      manageStepClass = "selected-pas";
   } else if (currentStep > number) {
      manageStepClass = "checked-pas";
   } else {
      manageStepClass = "";
   }

   return (
      <p className={`${manageStepClass}`}>
         <span>{number}</span>
         <span className="hidden">
            <img alt="" src={require("assets/images/check.png")} />
         </span>
      </p>
   );
}
